// Curated, confirmed-working royalty-free imagery (Unsplash / Pexels)
export const IMG = {
  heroMain: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/uo28r8i8_7f69e1d2-5a94-4394-9bb5-3b0f2a327e34.png",
  heroIndustrial: "https://images.pexels.com/photos/2569839/pexels-photo-2569839.jpeg?auto=compress&cs=tinysrgb&w=1920",
  heroAgriculture: "https://images.unsplash.com/photo-1692369584496-3216a88f94c1?w=1920&q=80&auto=format&fit=crop",
  factory: "https://images.unsplash.com/photo-1716643863806-989dd76ae093?w=1600&q=80&auto=format&fit=crop",
  waterFlow: "https://images.unsplash.com/photo-1498462440456-0dba182e775b?w=1600&q=80&auto=format&fit=crop",
  irrigation: "https://images.pexels.com/photos/17765487/pexels-photo-17765487.jpeg?auto=compress&cs=tinysrgb&w=1600",
  engine: "https://images.pexels.com/photos/10290625/pexels-photo-10290625.jpeg?auto=compress&cs=tinysrgb&w=1600",
  field: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1600&q=80&auto=format&fit=crop",
  farmer: "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=1600&q=80&auto=format&fit=crop",
  cityWater: "https://images.unsplash.com/photo-1583475020831-fb4fbb0a2f8b?w=1600&q=80&auto=format&fit=crop",
};

// Branded fallback used if any remote image fails to load
export const FALLBACK_IMG =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='800' height='800'><defs><linearGradient id='g' x1='0' y1='0' x2='1' y2='1'><stop offset='0' stop-color='#0D3B22'/><stop offset='1' stop-color='#165A36'/></linearGradient></defs><rect width='800' height='800' fill='url(#g)'/><circle cx='560' cy='260' r='90' fill='#F2A900' opacity='0.9'/><text x='60' y='700' font-family='sans-serif' font-size='72' fill='#F2A900' font-weight='800'>RK JAIN</text></svg>`
  );

export const CATEGORIES = [
  "All",
  "Pumps",
  "Pipes",
  "Cables",
  "Atta Chakki",
  "Chaff Cutter",
  "Drip Irrigation",
  "Spray Pumps",
  "Vacuum",
  "Generator",
  "STP",
];

export const BROCHURES = {
  suction: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/3nbkqwt2_WhatsApp%20Image%202026-07-26%20at%206.29.37%20PM.jpeg",
  chaff: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/1yy7ljr6_WhatsApp%20Image%202026-07-26%20at%206.25.59%20PM.jpeg",
  kflex: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/752738f1_WhatsApp%20Image%202026-07-26%20at%206.22.00%20PM.jpeg",
  garden: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/j105xkak_WhatsApp%20Image%202026-07-26%20at%206.20.05%20PM.jpeg",
  carwasher: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/22dexexc_WhatsApp%20Image%202026-07-26%20at%206.10.41%20PM.jpeg",
  mulching: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/boqsy8kw_WhatsApp%20Image%202026-07-26%20at%206.07.58%20PM.jpeg",
  alucable: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/zg4ct12g_WhatsApp%20Image%202026-07-26%20at%206.03.53%20PM.jpeg",
  pumpcable: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/ift5v7zc_WhatsApp%20Image%202026-07-26%20at%206.01.44%20PM.jpeg",
  columnpipe: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/6k69au79_WhatsApp%20Image%202026-07-26%20at%205.50.54%20PM.jpeg",
  aatachakki: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/kmpfpcr1_WhatsApp%20Image%202026-07-26%20at%205.48.35%20PM.jpeg",
  flourmill: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/f9y3chy7_WhatsApp%20Image%202026-07-26%20at%205.40.10%20PM.jpeg",
  pvcu: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/qv0555sz_WhatsApp%20Image%202026-07-26%20at%205.07.25%20PM.jpeg",
  hdpe: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/cz2f0rnq_WhatsApp%20Image%202026-07-26%20at%204.57.01%20PM.jpeg",
  v6pump: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/3wh0d5ed_WhatsApp%20Image%202026-07-26%20at%204.33.11%20PM.jpeg",
  v4pump: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/iug6ibau_WhatsApp%20Image%202026-07-26%20at%204.27.19%20PM.jpeg",
  selfprime: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/xb9unxox_WhatsApp%20Image%202026-07-26%20at%204.16.57%20PM%20%281%29.jpeg",
  openwell: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/255w4bw5_WhatsApp%20Image%202026-07-26%20at%204.23.25%20PM.jpeg",
  sprayers: "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/b82kay10_WhatsApp%20Image%202026-07-26%20at%204.09.05%20PM.jpeg",
  drip: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/z12kwjdo_WhatsApp%20Image%202026-07-26%20at%2011.53.11%20PM.jpeg",
  mudpump: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/ezkxztex_WhatsApp%20Image%202026-07-27%20at%2012.02.27%20AM%20%281%29.jpeg",
  motor: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/dp1nxofh_WhatsApp%20Image%202026-07-27%20at%2012.08.59%20AM.jpeg",
  discfilter: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/kpl1ppdr_WhatsApp%20Image%202026-07-26%20at%2011.51.32%20PM.jpeg",
  chaffbig: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/uzyhrrn4_WhatsApp%20Image%202026-07-26%20at%2011.43.24%20PM.jpeg",
  pepsidrip: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/n664ofbj_1593b3d9-9754-47bb-ae6b-8235d0e60fc1.jpg",
  rounddrip: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/c04dqxmo_WhatsApp%20Image%202026-07-26%20at%2011.35.21%20PM.jpeg",
  coppercable: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/fqly5g1a_WhatsApp%20Image%202026-07-27%20at%2012.23.51%20AM.jpeg",
  weeder: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/xu14uaih_WhatsApp%20Image%202026-07-27%20at%2012.33.47%20AM.jpeg",
  alucable2: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/0unz6ck9_WhatsApp%20Image%202026-07-27%20at%2012.38.24%20AM.jpeg",
  sprinkler: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/6uhzsm3t_WhatsApp%20Image%202026-07-27%20at%2012.58.12%20AM.jpeg",
  watertx: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/1fvvvef7_WhatsApp%20Image%202026-07-27%20at%201.15.01%20AM.jpeg",
  vacuum: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/rmxvb4qc_WhatsApp%20Image%202026-07-27%20at%2012.10.57%20AM%20%281%29.jpeg",
  generator: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/tz0pt2o4_WhatsApp%20Image%202026-07-27%20at%201.19.57%20AM.jpeg",
  monoblock: "https://customer-assets-eiarnc6j.emergentagent.net/job_6c6be9be-cf41-4d74-b70f-b1fa3981caba/artifacts/pe5lhr8e_WhatsApp%20Image%202026-07-27%20at%201.34.25%20AM.jpeg",
};

// Clean product-only thumbnails (AI-cropped from the sprayer catalog brochure + Nano Banana cutouts)
export const PRODUCT_IMG = {
  // Sprayer catalog (Pillow-cropped from 2x4 grid)
  htp22a:      "/products/htp22a.jpeg",
  htp30a:      "/products/htp30a.jpeg",
  htp50a:      "/products/htp50a.jpeg",
  portable:    "/products/portable.jpeg",
  knapsack:    "/products/knapsack.jpeg",
  htp22a_set:  "/products/htp22a_set.jpeg",
  htp30a_set:  "/products/htp30a_set.jpeg",
  accessories: "/products/accessories.jpeg",
  // Legacy brochure products (Gemini Nano Banana AI cutouts)
  v6:          "/products/v6-submersible-pump.png",
  v4:          "/products/v4-submersible-pump.png",
  selfprime:   "/products/self-priming-pump.png",
  openwell:    "/products/openwell-pump.png",
  aatachakki:  "/products/aata-chakki-regular.jpeg",
  flourmill:   "/products/flour-mill.png",
  pvcu:        "/products/pvc-u-agriculture-pipes.png",
  hdpe:        "/products/hdpe-pipes-sdr11.png",
  suction:     "/products/pvc-suction-hose-pipe.png",
  chaff:       "/products/mini-chaff-cutter-rkc-1.png",
  kflex:       "/products/k-flex-submain-pipes.png",
  garden:      "/products/premium-garden-pipe.png",
  carwasher:   "/products/high-pressure-car-washer-rk-2100.png",
  mulching:    "/products/black-white-mulching-film.png",
  alucable:    "/products/aluminium-armoured-cable.png",
  pumpcable:   "/products/submersible-pump-cable.png",
  columnpipe:  "/products/column-pipes-borewell.png",
  drip:        "/products/drip-irrigation-tape.png",
  mudpump:     "/products/mud-pump.png",
  motor:       "/products/electric-motor.png",
  discfilter:  "/products/disc-filter.png",
  chaffbig:    "/products/heavy-duty-chaff-cutter.png",
  pepsidrip:   "/products/pepsi-drip.png",
  rounddrip:   "/products/round-drip.png",
  coppercable: "/products/copper-cable.png",
  weeder:      "/products/power-weeder-rj70-deluxe.png",
  alucable2:   "/products/aluminum-cable.png",
  sprinkler:   "/products/sprinkler-pipes.png",
  watertx:     "/products/water-transfer-pump.png",
  vacuum:      "/products/wet-dry-vacuum-cleaner.png",
  generator:   "/products/generator.png",
  monoblock:   "/products/monoblock-pump.png",
};

export const PRODUCTS = [
  // ── HTP Spray Pumps & Sprayers (from the RK Jain Pumps sprayers catalog) ──
  {
    slug: "htp-spray-pump-22a",
    name: "HTP Spray Pump 22A",
    category: "STP",
    subcategory: "HTP Spray Pump",
    model: "HTP-22A",
    image: PRODUCT_IMG.htp22a,
    brochureImage: BROCHURES.sprayers,
    brochure: BROCHURES.sprayers,
    short: "Powerful | Durable | Efficient — high-pressure HTP spray pump for agriculture & garden.",
    overview:
      "The RK Jain HTP Spray Pump 22A is a powerful, durable and efficient high-pressure sprayer for agriculture, orchards, gardens and pest-control operations. Built with high-quality brass valves, a robust cast body and a heavy red flywheel — delivered as a bare pump unit ready to couple with your motor or engine.",
    specs: [
      ["Model", "HTP 22A"],
      ["Power Required", "2 – 3 HP"],
      ["Working Pressure", "15 – 25 kg/cm²"],
      ["Suction / Discharge", "22 – 30 L/min"],
      ["Build", "Brass valves · Cast body · Heavy flywheel"],
    ],
    note: "Specifications are subject to change without prior notice.",
    sizes: ["Bare Pump — 2 to 3 HP compatible"],
    features: [
      "Powerful — high working pressure for tough spraying jobs",
      "Durable — robust cast body & heavy flywheel for long life",
      "Efficient — brass valves ensure smooth flow & low maintenance",
      "Versatile — ideal for agriculture, orchards & pest control",
      "Easy Coupling — bare pump for motor or engine operation",
    ],
    advantages: [
      "Trusted HTP Design",
      "Low Maintenance",
      "High Pressure Output",
      "Long Service Life",
    ],
    applications: ["Agriculture", "Commercial"],
  },
  {
    slug: "htp-spray-pump-30a",
    name: "HTP Spray Pump 30A",
    category: "STP",
    subcategory: "HTP Spray Pump",
    model: "HTP-30A",
    image: PRODUCT_IMG.htp30a,
    brochureImage: BROCHURES.sprayers,
    brochure: BROCHURES.sprayers,
    short: "Powerful | Durable | Efficient — heavy-duty 30A HTP spray pump for larger farms.",
    overview:
      "The RK Jain HTP Spray Pump 30A steps up capacity for mid-to-large farms. Higher discharge, stronger pressure and a heavier build make it ideal for extensive orchards, plantations and commercial spraying — delivered as a bare pump for motor or engine coupling.",
    specs: [
      ["Model", "HTP 30A"],
      ["Power Required", "3 – 5 HP"],
      ["Working Pressure", "15 – 30 kg/cm²"],
      ["Suction / Discharge", "30 – 40 L/min"],
      ["Build", "Brass valves · Cast body · Heavy flywheel"],
    ],
    note: "Specifications are subject to change without prior notice.",
    sizes: ["Bare Pump — 3 to 5 HP compatible"],
    features: [
      "Higher Discharge — 30 to 40 L/min for large-area spraying",
      "Durable Build — heavy cast body for continuous duty",
      "Efficient Design — brass valves & precise machining",
      "Best For — orchards, plantations & commercial farms",
      "Easy Maintenance — accessible service points",
    ],
    advantages: [
      "High Capacity",
      "Trusted HTP Design",
      "Reliable & Rugged",
      "Long Service Life",
    ],
    applications: ["Agriculture", "Commercial"],
  },
  {
    slug: "htp-spray-pump-50a",
    name: "HTP Spray Pump 50A",
    category: "STP",
    subcategory: "HTP Spray Pump",
    model: "HTP-50A",
    image: PRODUCT_IMG.htp50a,
    brochureImage: BROCHURES.sprayers,
    brochure: BROCHURES.sprayers,
    short: "Powerful | Durable | Efficient — flagship 50A HTP spray pump for large plantations.",
    overview:
      "The RK Jain HTP Spray Pump 50A is our flagship high-pressure sprayer — engineered for the toughest spraying tasks across large orchards, plantations and commercial farms. Maximum pressure, maximum discharge, built to run all day.",
    specs: [
      ["Model", "HTP 50A"],
      ["Power Required", "5 – 7.5 HP"],
      ["Working Pressure", "20 – 40 kg/cm²"],
      ["Suction / Discharge", "40 – 60 L/min"],
      ["Build", "Brass valves · Heavy cast body · Reinforced flywheel"],
    ],
    note: "Specifications are subject to change without prior notice.",
    sizes: ["Bare Pump — 5 to 7.5 HP compatible"],
    features: [
      "Flagship Performance — up to 40 kg/cm² working pressure",
      "Highest Discharge — up to 60 L/min for widest coverage",
      "Heavy-Duty Construction — all-day continuous operation",
      "Best For — large orchards, plantations & industrial use",
      "Brass Valve Assembly — smooth, leak-free performance",
    ],
    advantages: [
      "Highest Pressure & Flow",
      "Continuous-Duty Rated",
      "Rugged Cast Construction",
      "Premium RK Jain Quality",
    ],
    applications: ["Agriculture", "Commercial", "Industrial"],
  },
  {
    slug: "portable-power-sprayer",
    name: "Portable Power Sprayer (4 Stroke Engine)",
    category: "Spray Pumps",
    subcategory: "Knapsack Power Sprayer",
    model: "4 Stroke Engine · 20 L",
    image: PRODUCT_IMG.portable,
    brochureImage: BROCHURES.sprayers,
    brochure: BROCHURES.sprayers,
    short: "Petrol-powered knapsack sprayer with 4-stroke engine & 20 L tank — for field & garden.",
    overview:
      "The RK Jain Portable Power Sprayer is a comfortable, back-mounted knapsack sprayer powered by a fuel-efficient 4-stroke petrol engine. A large 20-litre tank, low-vibration engine and ergonomic straps make it perfect for field & garden spraying without any electricity or hose reel.",
    specs: [
      ["Type", "Portable Knapsack Power Sprayer"],
      ["Engine", "4 Stroke (Petrol)"],
      ["Tank Capacity", "20 Litre"],
      ["Application", "Field & Garden Use"],
      ["Design", "Ergonomic Back-Mount · Low Vibration"],
    ],
    sizes: ["20 Litre · 4 Stroke Petrol Engine"],
    features: [
      "Fuel Efficient — clean, low-emission 4 stroke engine",
      "Comfortable Back-Mount — ergonomic straps for long use",
      "Large 20 L Tank — fewer refills, more coverage",
      "Cordless & Hose-Free — go anywhere on the farm",
      "Low Vibration — easier on the operator",
    ],
    advantages: [
      "No Electricity Needed",
      "Ideal for Remote Fields",
      "Powerful Spraying",
      "Reliable RK Jain Build",
    ],
    applications: ["Agriculture", "Residential", "Commercial"],
  },
  {
    slug: "knapsack-battery-sprayer",
    name: "Knapsack Battery Sprayer",
    category: "Spray Pumps",
    subcategory: "Battery Sprayer",
    model: "20 L · 12V / 12Ah",
    image: PRODUCT_IMG.knapsack,
    brochureImage: BROCHURES.sprayers,
    brochure: BROCHURES.sprayers,
    short: "Easy to use | High performance — rechargeable 20L battery sprayer for effortless spraying.",
    overview:
      "The RK Jain Knapsack Battery Sprayer takes the effort out of spraying. A rechargeable 12V/12Ah battery drives a powerful pump for hours of continuous operation, a 20-litre tank covers wide areas, and a comfortable back-mount design makes it a joy to use.",
    specs: [
      ["Type", "Rechargeable Knapsack Battery Sprayer"],
      ["Tank Capacity", "20 Litre"],
      ["Battery", "12V / 12Ah (Rechargeable)"],
      ["Working Pressure", "3.5 – 5.5 Bar"],
      ["Design", "Comfortable Back-Mount"],
    ],
    sizes: ["20 Litre · 12V / 12Ah"],
    features: [
      "Easy to Use — one-button spraying, no manual pumping",
      "High Performance — 3.5 to 5.5 Bar working pressure",
      "Long Battery Life — hours of continuous operation",
      "20 L Capacity — wide-area coverage on a single fill",
      "Silent Operation — quiet motor for peaceful use",
    ],
    advantages: [
      "No Fuel or Cord",
      "Rechargeable & Portable",
      "Consistent Pressure",
      "Effortless Spraying",
    ],
    applications: ["Agriculture", "Residential", "Commercial"],
  },
  {
    slug: "htp-spray-pump-22a-set",
    name: "HTP Spray Pump 22A (Set with Engine)",
    category: "STP",
    subcategory: "HTP Spray Pump Set",
    model: "HTP-22A + 5.5 HP Engine",
    image: PRODUCT_IMG.htp22a_set,
    brochureImage: BROCHURES.sprayers,
    brochure: BROCHURES.sprayers,
    short: "Complete set with 5.5 HP petrol engine + HTP 22A spray pump — ready to spray.",
    overview:
      "The RK Jain HTP Spray Pump 22A Set is a complete, ready-to-run spraying system — a proven HTP 22A pump paired with a 5.5 HP petrol engine on a heavy-duty welded steel frame. Just add fuel and hoses and you're ready to spray.",
    specs: [
      ["Model", "HTP 22A Set"],
      ["Engine Power", "5.5 HP (Petrol)"],
      ["Working Pressure", "15 – 25 kg/cm²"],
      ["Suction / Discharge", "22 – 30 L/min"],
      ["Frame", "Heavy Duty Welded Steel"],
    ],
    note: "Specifications are subject to change without prior notice.",
    sizes: ["Complete Set — HTP 22A + 5.5 HP Petrol Engine"],
    features: [
      "Complete Solution — pump, engine & frame together",
      "Ready to Spray — plug hoses and start spraying",
      "Heavy Duty Frame — welded steel base for stability",
      "Portable — compact footprint, easy to move",
      "Reliable Power — 5.5 HP petrol engine for consistent output",
    ],
    advantages: [
      "Pre-Coupled & Aligned",
      "Grid-Independent",
      "Perfect for On-Site Spraying",
      "Trusted RK Jain Quality",
    ],
    applications: ["Agriculture", "Commercial", "Industrial"],
  },
  {
    slug: "htp-spray-pump-30a-set",
    name: "HTP Spray Pump 30A (Set with Engine)",
    category: "STP",
    subcategory: "HTP Spray Pump Set",
    model: "HTP-30A + 6.5 HP Engine",
    image: PRODUCT_IMG.htp30a_set,
    brochureImage: BROCHURES.sprayers,
    brochure: BROCHURES.sprayers,
    short: "Complete set with 6.5 HP engine + HTP 30A spray pump — heavy-duty on-field spraying.",
    overview:
      "The RK Jain HTP Spray Pump 30A Set is our heavier-duty on-field spraying system — the HTP 30A high-discharge pump paired with a rugged 6.5 HP engine on a welded steel base. Built for large orchards and continuous commercial spraying.",
    specs: [
      ["Model", "HTP 30A Set"],
      ["Engine Power", "6.5 HP"],
      ["Working Pressure", "15 – 30 kg/cm²"],
      ["Suction / Discharge", "30 – 40 L/min"],
      ["Frame", "Heavy Duty Welded Steel"],
    ],
    note: "Specifications are subject to change without prior notice.",
    sizes: ["Complete Set — HTP 30A + 6.5 HP Engine"],
    features: [
      "Higher Discharge — up to 40 L/min for wide-area coverage",
      "Complete Set — pump, engine & frame ready to run",
      "Heavy Duty — 6.5 HP engine for continuous work",
      "Sturdy Frame — welded steel for on-site durability",
      "Best For — orchards, plantations & commercial farms",
    ],
    advantages: [
      "Pre-Coupled & Aligned",
      "Grid-Independent",
      "High Capacity",
      "Rugged & Reliable",
    ],
    applications: ["Agriculture", "Commercial", "Industrial"],
  },
  {
    slug: "sprayer-accessories",
    name: "Sprayer Accessories",
    category: "STP",
    subcategory: "Spray Accessories",
    model: "Premium Range",
    image: PRODUCT_IMG.accessories,
    brochureImage: BROCHURES.sprayers,
    brochure: BROCHURES.sprayers,
    short: "Premium quality accessories — high pressure hose, spray gun, suction filter, nozzles & fittings.",
    overview:
      "A complete range of premium quality sprayer accessories to keep your RK Jain sprayer performing at its best — high-pressure hose pipes, precision spray guns, suction filters, brass nozzles and fittings. Built to last, engineered for perfect fit.",
    specs: [
      ["High Pressure Hose Pipe", "Reinforced · Kink Resistant"],
      ["Suction Filter", "Mesh Filter for Clean Intake"],
      ["Spray Gun", "Precision Trigger · Adjustable Nozzle"],
      ["Nozzles & Fittings", "Brass — Corrosion Resistant"],
    ],
    sizes: ["Hose Pipe · Suction Filter · Spray Gun · Brass Nozzles & Fittings"],
    features: [
      "High Pressure Hose Pipe — reinforced for tough field use",
      "Suction Filter — protects the pump from debris",
      "Precision Spray Gun — adjustable, comfortable trigger",
      "Brass Nozzles & Fittings — corrosion resistant & long life",
      "Perfect Fit — engineered for RK Jain sprayers",
    ],
    advantages: [
      "Genuine RK Jain Quality",
      "Long Service Life",
      "Perfect Fit & Finish",
      "Value-for-Money Range",
    ],
    applications: ["Agriculture", "Commercial", "Residential"],
  },
  {
    slug: "v6-submersible-pump",
    name: "V6 Water Filled Submersible Pump Set (150mm)",
    category: "Pumps",
    subcategory: "V6 Submersible Pump",
    model: "V6-10 to V6-30",
    brochure: BROCHURES.v6pump,
    brochureImage: BROCHURES.v6pump,
    short: "Power that runs deep — 150mm OD water-filled submersible pump set (Ishwar Pumps).",
    image: PRODUCT_IMG.v6,
    overview:
      "The RK Jain V6 Water Filled Submersible Pump Set (150mm OD) is designed for high performance and built for long life. Its water-filled design gives efficient cooling, while a high-grade stainless steel body and high-torque motor deliver dependable high-head performance for deep borewells.",
    specs: [
      ["Model", "HP / Stages / Discharge / Bore / Max Head / Max Discharge"],
      ["V6-10", "1.0 HP / 10 / 1.25\" / 6\" / 75 m / 6000 LPH"],
      ["V6-15", "1.5 HP / 15 / 1.25\" / 6\" / 100 m / 6000 LPH"],
      ["V6-20", "2.0 HP / 20 / 1.25\" / 6\" / 135 m / 6000 LPH"],
      ["V6-25", "2.5 HP / 25 / 1.25\" / 6\" / 165 m / 6000 LPH"],
      ["V6-30", "3.0 HP / 30 / 1.25\" / 6\" / 200 m / 6000 LPH"],
    ],
    note: "Specifications are subject to change without prior notice.",
    sizes: ["V6-10 (1.0 HP)", "V6-15 (1.5 HP)", "V6-20 (2.0 HP)", "V6-25 (2.5 HP)", "V6-30 (3.0 HP)"],
    features: [
      "Water Filled Design — efficient cooling for better performance & longer life",
      "High Efficiency — maximum output with minimum power consumption",
      "Rust & Corrosion Resistant — high grade stainless steel & special coating",
      "Powerful Motor — high torque motor for consistent performance",
      "Easy Installation — compact, robust and easy to install",
    ],
    advantages: [
      "Water filled motor for better cooling",
      "High grade stainless steel body",
      "High performance & high head",
      "Low maintenance & long life",
      "Tested for safety & performance",
    ],
    applications: ["Agriculture", "Residential", "Industrial", "Water Supply"],
  },
  {
    slug: "v4-submersible-pump",
    name: "V4 Borewell Submersible Pump",
    category: "Pumps",
    subcategory: "V4 Submersible Pump",
    model: "V4-10 to V4-30",
    brochure: BROCHURES.v4pump,
    brochureImage: BROCHURES.v4pump,
    short: "Power that reaches deeper — SS 304 borewell submersible pump, built to last.",
    image: PRODUCT_IMG.v4,
    overview:
      "The RK Jain V4 Borewell Submersible Pump is built for performance and built to last. Made with high grade SS 304 material for corrosion resistance, with a powerful motor for high performance in all conditions — suitable for farms, homes, industries and irrigation.",
    specs: [
      ["Model", "HP / Stage / Outlet / Bore Size"],
      ["V4-10", "1.0 HP / 10 / 1.25\" / 4\""],
      ["V4-15", "1.5 HP / 15 / 1.25\" / 4\""],
      ["V4-20", "2.0 HP / 20 / 1.25\" / 4\""],
      ["V4-25", "2.5 HP / 25 / 1.25\" / 4\""],
      ["V4-30", "3.0 HP / 30 / 1.25\" / 4\""],
    ],
    note: "Specifications are subject to change without prior notice.",
    sizes: ["V4-10 (1.0 HP)", "V4-15 (1.5 HP)", "V4-20 (2.0 HP)", "V4-25 (2.5 HP)", "V4-30 (3.0 HP)"],
    features: [
      "High Efficiency — maximum output with minimum power consumption",
      "Corrosion Resistant — made with high grade SS 304 material",
      "Powerful Motor — built for high performance in all conditions",
      "Long Life — designed for durability and long life",
      "Wide Application — suitable for farms, homes, industries & irrigation",
    ],
    advantages: [
      "High Efficiency",
      "Powerful Performance",
      "Rust Resistant",
      "Easy to Install",
      "Long Life",
    ],
    applications: ["Agriculture", "Residential", "Industrial", "Water Supply"],
  },
  {
    slug: "self-priming-pump",
    name: "Self Priming Pump (RKSPS)",
    category: "Pumps",
    subcategory: "Self Priming Monoblock Pump",
    model: "RKSPS-05 to RKSPS-3.0",
    brochure: BROCHURES.selfprime,
    brochureImage: BROCHURES.selfprime,
    short: "High performance | self priming | long life — no foot valve required, suction lift up to 8m.",
    image: PRODUCT_IMG.selfprime,
    overview:
      "The RK Jain Self Priming Pump (RKSPS series) needs no foot valve and offers high suction lift up to 8 meters with high discharge and efficiency. A rust-proof body, high-efficiency motor and 100% copper winding make it ideal for continuous operation — backed by a 1 year warranty.",
    specs: [
      ["Model", "HP / RPM / Discharge / Suction / Head / Discharge / Suction Lift / Weight"],
      ["RKSPS-05", "0.5 / 2880 / 25×25 / 25×25 / 30 m / 40 LPM / 8 m / 12 kg"],
      ["RKSPS-1.0", "1.0 / 2880 / 25×25 / 25×25 / 36 m / 60 LPM / 8 m / 14 kg"],
      ["RKSPS-1.5", "1.5 / 2880 / 40×40 / 40×40 / 40 m / 90 LPM / 8 m / 20 kg"],
      ["RKSPS-2.0", "2.0 / 2880 / 40×40 / 40×40 / 45 m / 120 LPM / 8 m / 24 kg"],
      ["RKSPS-3.0", "3.0 / 2880 / 50×50 / 50×50 / 50 m / 150 LPM / 8 m / 35 kg"],
    ],
    note: "Specifications are subject to change without prior notice. Rust Proof Body · High Efficiency Motor · 100% Copper Winding · Low Power Consumption · Warranty 1 Year.",
    sizes: ["RKSPS-05 (0.5 HP)", "RKSPS-1.0 (1.0 HP)", "RKSPS-1.5 (1.5 HP)", "RKSPS-2.0 (2.0 HP)", "RKSPS-3.0 (3.0 HP)"],
    features: [
      "Self Priming — no foot valve required",
      "High Suction Lift — up to 8 meter",
      "High Discharge & Efficiency",
      "Strong & Compact Design · Heavy Duty Construction",
      "Low Power Consumption · High Quality Mechanical Seal",
      "Ideal for Continuous Operation · Easy to Install & Maintain",
    ],
    advantages: [
      "Rust Proof Body",
      "High Efficiency Motor",
      "100% Copper Winding",
      "Low Power Consumption",
      "1 Year Warranty",
    ],
    applications: ["Agriculture", "Residential", "Industrial", "Construction"],
  },
  {
    slug: "openwell-pump",
    name: "Openwell Submersible Pump",
    category: "Pumps",
    subcategory: "Openwell Pump",
    model: "Openwell",
    brochure: BROCHURES.openwell,
    brochureImage: BROCHURES.openwell,
    short: "High efficiency, powerful & rust-resistant openwell submersible pump for open wells & tanks.",
    image: PRODUCT_IMG.openwell,
    overview:
      "The RK Jain Openwell Submersible Pump delivers powerful, high-efficiency performance for open wells, tanks and sumps. Rust-resistant, low-maintenance and built for long life with dependable, reliable support.",
    specs: [
      ["Type", "Openwell Submersible Pump"],
      ["Build", "Rust Resistant · Heavy Duty"],
      ["Performance", "High Efficiency · Powerful"],
      ["Maintenance", "Low Maintenance · Long Life"],
    ],
    sizes: ["Multiple HP options available — please enquire"],
    features: [
      "High Efficiency",
      "Powerful Performance",
      "Rust Resistant",
      "Low Maintenance",
      "Long Life",
    ],
    advantages: [
      "Powerful & Reliable",
      "Rust Resistant Build",
      "Low Maintenance",
      "Long Service Life",
    ],
    applications: ["Agriculture", "Water Supply", "Residential", "Industrial"],
  },
  {
    slug: "aata-chakki-regular",
    name: "RK Jain Aata Chakki (Regular 1.5)",
    category: "Atta Chakki",
    subcategory: "Domestic Flour Mill",
    model: "Regular 1.5",
    brochure: BROCHURES.aatachakki,
    brochureImage: BROCHURES.aatachakki,
    short: "Power. Performance. Pure Results. — every grain, pure flour, our promise.",
    image: PRODUCT_IMG.aatachakki,
    overview:
      "The RK Jain Aata Chakki (Regular 1.5) is a modern domestic flour mill with an ISO Energy Saver Motor. High performance, low power consumption and a strong body for long life — grinds all types of grains to a fine, fresh, pure flour at home.",
    specs: [
      ["Model", "Regular 1.5"],
      ["Motor", "ISO Certified Energy Saver Motor"],
      ["Warranty", "1 Year Warranty"],
      ["Grinds", "Wheat, Maize, Jowar, Bajra, Chana, Soybean, Moong, Spices, Rice & other grains"],
    ],
    sizes: ["Regular 1.5 · Energy Saver Motor"],
    features: [
      "High Performance Motor",
      "High Quality Material",
      "Low Power Consumption, More Output",
      "Strong Body, Long Life",
      "Best Grinding of All Grains",
      "Low Maintenance, Easy Operation",
    ],
    advantages: [
      "Best Quality Guarantee",
      "Durable & Reliable Build",
      "Low Power, More Savings",
      "1 Year Warranty",
    ],
    applications: ["Residential", "Commercial"],
  },
  {
    slug: "flour-mill",
    name: "RK Jain Flour Mill",
    category: "Atta Chakki",
    subcategory: "Commercial Flour Mill",
    model: "Heavy Duty",
    brochure: BROCHURES.flourmill,
    brochureImage: BROCHURES.flourmill,
    short: "Every grain, a promise of the finest grinding — heavy duty flour mill for shops & industry.",
    image: PRODUCT_IMG.flourmill,
    overview:
      "The RK Jain Flour Mill is a heavy-duty, durable machine built for the finest grinding. Strong construction, high performance motor and low maintenance make it the best choice for flour mills, grocery shops and industry — with customer satisfaction as the first priority.",
    specs: [
      ["Type", "Heavy Duty Flour Mill"],
      ["Motor", "High Performance Motor"],
      ["Build", "Strong Construction, Long Life"],
      ["Grinds", "Wheat, Maize, Jowar, Bajra, Chana, Soybean, Moong, Spices, Rice & other grains"],
      ["Best For", "Flour Mill, Grocery Shop & Industry"],
    ],
    sizes: ["Heavy Duty Commercial Model"],
    features: [
      "Best Quality Grinding",
      "Low Maintenance, Easy Operation",
      "Heavy Duty & Durable Machine",
      "Best for Flour Mill, Grocery Shop & Industry",
      "Customer Satisfaction — Our First Priority",
    ],
    advantages: [
      "Best Quality",
      "Durable & Reliable",
      "Low Maintenance",
      "Customer Satisfaction",
    ],
    applications: ["Commercial", "Industrial", "Residential"],
  },
  {
    slug: "pvc-u-agriculture-pipes",
    name: "PVC-U Agriculture Pipes & Fittings",
    category: "Pipes",
    subcategory: "PVC-U Pipes & Fittings",
    model: "20mm – 160mm",
    brochure: BROCHURES.pvcu,
    brochureImage: BROCHURES.pvcu,
    short: "Strong · Durable · Leak Proof · Long Life — complete PVC-U pipes & fittings range.",
    image: PRODUCT_IMG.pvcu,
    overview:
      "RK Jain PVC-U Agriculture Pipes & Fittings offer a complete range — pipes (20mm to 160mm), all types of fittings, ball valves, brass insert fittings and solvent cement. Built for high pressure and tough conditions with leak-proof, corrosion-resistant, eco-friendly performance.",
    specs: [
      ["Size (mm)", "OD (mm) / Wall Thickness / Working Pressure"],
      ["20", "20 / 1.5 mm / 6 kg/cm²"],
      ["25", "25 / 1.6 mm / 6 kg/cm²"],
      ["32", "32 / 1.8 mm / 6 kg/cm²"],
      ["40", "40 / 2.0 mm / 6 kg/cm²"],
      ["50", "50 / 2.4 mm / 6 kg/cm²"],
      ["63", "63 / 3.0 mm / 6 kg/cm²"],
      ["75", "75 / 3.6 mm / 6 kg/cm²"],
      ["90", "90 / 4.3 mm / 6 kg/cm²"],
      ["110", "110 / 5.3 mm / 6 kg/cm²"],
      ["160", "160 / 7.7 mm / 6 kg/cm²"],
    ],
    note: "Pipe Specifications (SWR). Our range: PVC-U Pipes, PVC-U Fittings (all types), PVC-U Valves (ball valve), Brass Insert Fittings, Solvent Cement.",
    sizes: ["Complete range 20mm to 160mm — pipes & fittings available"],
    features: [
      "High Strength — built for high pressure & tough conditions",
      "Leak Proof — perfect joints for zero leakage",
      "Corrosion Resistant — resistant to chemicals, rust & scaling",
      "Long Life — durable performance with low maintenance",
      "Eco Friendly — safe for agriculture & environment",
    ],
    advantages: [
      "Premium Quality — Assured Performance",
      "Perfect Fit — Easy Installation",
      "Cost Effective — Value for Money",
      "Trusted Brand — RK Jain Pipes",
    ],
    applications: ["Agriculture", "Water Supply", "Irrigation", "Industrial"],
  },
  {
    slug: "hdpe-pipes-sdr11",
    name: "HDPE Pipes",
    category: "Pipes",
    subcategory: "HDPE Pipes",
    model: "SDR 11 · 20mm – 200mm",
    brochure: BROCHURES.hdpe,
    brochureImage: BROCHURES.hdpe,
    short: "Perfect solution for a better tomorrow — Durable | Leak Proof | Rust Free | Long Life.",
    image: PRODUCT_IMG.hdpe,
    overview:
      "RK Jain HDPE Pipes are the perfect solution for a better tomorrow — high strength to withstand pressure and impact, 100% leak-proof joints, corrosion resistant and eco-friendly. Ideal for drinking water, irrigation, industrial and underground applications.",
    specs: [
      ["Size (mm)", "OD (mm) / Wall Thickness / Working Pressure"],
      ["20", "20 / 2.0 mm / 16 Bar"],
      ["25", "25 / 2.3 mm / 16 Bar"],
      ["32", "32 / 3.0 mm / 16 Bar"],
      ["40", "40 / 3.7 mm / 16 Bar"],
      ["50", "50 / 4.6 mm / 16 Bar"],
      ["63", "63 / 5.8 mm / 16 Bar"],
      ["75", "75 / 6.8 mm / 16 Bar"],
      ["90", "90 / 8.2 mm / 16 Bar"],
      ["110", "110 / 10.0 mm / 16 Bar"],
      ["160", "160 / 14.6 mm / 16 Bar"],
      ["200", "200 / 18.2 mm / 16 Bar"],
    ],
    note: "HDPE Pipe Specification (SDR 11). *Other sizes and SDR series available on request.",
    sizes: ["20mm to 200mm (SDR 11) · Other sizes & SDR series on request"],
    features: [
      "Strong & Durable — withstands high pressure & external impact",
      "Leak Proof Joints — 100% leak proof for reliable performance",
      "Chemical & Corrosion Resistant — resists chemicals, acids & harsh conditions",
      "Long Life & Low Maintenance — durable and long lasting",
      "Light Weight & Easy to Install",
      "100% Recyclable — eco friendly & safe for drinking water",
    ],
    advantages: [
      "Best Quality & Cost Effective",
      "Agriculture, Drinking Water & Industrial Use",
      "Underground Pipeline & Water Distribution",
      "Cable Duct Protection",
    ],
    applications: ["Water Supply", "Agriculture", "Industrial", "Construction"],
  },
  {
    slug: "pvc-suction-hose-pipe",
    name: "PVC Suction Hose Pipe",
    category: "Pipes",
    subcategory: "Suction Hose Pipe",
    model: "1 Inch (25mm)",
    brochure: BROCHURES.suction,
    brochureImage: BROCHURES.suction,
    short: "Heavy duty, flexible & multi-purpose PVC suction hose — ideal for agriculture, borewell, industrial & domestic use.",
    image: PRODUCT_IMG.suction,
    overview:
      "RK Jain PVC Suction Hose Pipe is a heavy-duty, flexible and multi-purpose hose engineered for water suction & discharge. Made from high quality PVC with a smooth inner surface for strong suction power and low friction — ideal for Agriculture, Borewell, Industrial & Domestic use.",
    specs: [
      ["Material", "High Quality PVC"],
      ["Type", "Suction Hose Pipe"],
      ["Size", "1 Inch (25mm)"],
      ["Length", "30 Meter"],
      ["Color", "Green"],
      ["Working Pressure", "4 - 6 kg/cm² (Approx.)"],
      ["Application", "Water Suction & Discharge"],
      ["Use", "Agriculture, Borewell, Industrial & Domestic"],
    ],
    sizes: ["1 Inch (25mm) — 30 Meter (Heavy Duty Thick Pipe)"],
    features: [
      "High Flexibility — easy to bend, roll & install",
      "Heavy Duty Build — high quality PVC for long life & extra strength",
      "Strong Suction Power — smooth inner surface, high flow, low friction",
      "Weather & UV Resistant — works in all weather conditions",
      "Light Weight — easy to carry, handle & transport",
      "Cost Effective — low maintenance & high performance",
    ],
    advantages: [
      "Excellent Suction Capacity",
      "Kink & Abrasion Resistant",
      "Corrosion & Chemical Resistant",
      "Long Life & Durable",
      "Best for Continuous Use",
    ],
    applications: ["Agriculture", "Water Supply", "Industrial", "Residential"],
  },
  {
    slug: "mini-chaff-cutter-rkc-1",
    name: "Mini Chaff Cutter (RKC-1)",
    category: "Chaff Cutter",
    subcategory: "Chaff Cutter",
    model: "RKC-1",
    brochure: BROCHURES.chaff,
    brochureImage: BROCHURES.chaff,
    short: "Small machine, big benefits — for cutting green fodder, dry grass, straw, maize & more.",
    image: PRODUCT_IMG.chaff,
    overview:
      "The RK Jain Mini Chaff Cutter (RKC-1) is a compact, powerful fodder cutter — the smart farmer's choice. Ideal for cutting Green Fodder, Dry Grass, Straw, Maize, Bajra, Jowar and more with fast, fine and uniform results.",
    specs: [
      ["Model", "RKC-1"],
      ["Motor Power", "2 HP (Single Phase)"],
      ["Speed", "2800 RPM"],
      ["Production Capacity", "400 – 600 kg/hr*"],
      ["No. of Blades", "4 (High Carbon Steel)"],
      ["Cutting Size", "10 – 20 mm (Approx.)"],
      ["Operation", "Electric"],
      ["Weight (Approx.)", "45 – 50 kg"],
    ],
    note: "*Production capacity may vary depending on material & moisture.",
    sizes: ["Model RKC-1 · 2 HP Single Phase"],
    features: [
      "Sharp Blades — hardened steel blades for fast & fine cutting",
      "Powerful Motor — high performance motor for smooth operation",
      "Multi Purpose — cuts Green Fodder, Dry Grass, Straw, Maize, Bajra, Jowar etc.",
      "Heavy Duty Body — strong & durable MS body for long life",
      "Compact & Portable — easy to move, operate & store",
      "Cost Effective — saves time, labour & increases productivity",
    ],
    advantages: [
      "High Cutting Efficiency",
      "Low Power Consumption",
      "Easy Maintenance",
      "Safe & User Friendly",
      "Best for Every Farmer",
    ],
    applications: ["Agriculture", "Commercial", "Industrial"],
  },
  {
    slug: "k-flex-submain-pipes",
    name: "K-FLEX Submain Pipes",
    category: "Drip Irrigation",
    subcategory: "Submain Pipe",
    model: "K-FLEX",
    brochure: BROCHURES.kflex,
    brochureImage: BROCHURES.kflex,
    short: "For efficient, durable & sustainable irrigation — trusted by farmers, chosen for quality.",
    image: PRODUCT_IMG.kflex,
    overview:
      "RK Jain K-FLEX Submain Pipes are made for efficient, durable and sustainable irrigation. Manufactured from premium raw material with high flexibility and uniform wall thickness for zero leakage — Made in India, built to last.",
    specs: [
      ["Product", "K-FLEX Submain Pipes"],
      ["Raw Material", "Premium Grade"],
      ["Standard", "AN ISO 9001 : 2015 Certified Company"],
      ["Origin", "Made in India"],
      ["Feature", "High Flexibility · UV & Weather Resistant · Leak Proof"],
    ],
    sizes: ["63 mm", "75 mm", "90 mm", "110 mm", "125 mm", "140 mm", "160 mm", "Other sizes available on request"],
    features: [
      "High Flexibility — easy to install, suitable for all types of terrain",
      "Extra Strength — high quality raw material for long life & reliability",
      "Leak Proof — uniform wall thickness ensures zero leakage",
      "UV & Weather Resistant — withstands harsh sunlight & extreme weather",
      "Clog Resistant — smooth inner surface for uninterrupted water flow",
      "Cost Effective — low maintenance and high performance",
    ],
    advantages: [
      "Premium Raw Material",
      "High Flexibility",
      "UV Resistant",
      "Long Life Performance",
      "Made in India",
    ],
    applications: ["Irrigation", "Agriculture", "Commercial", "Residential"],
  },
  {
    slug: "premium-garden-pipe",
    name: "Premium Garden Pipe",
    category: "Pipes",
    subcategory: "Garden Pipe",
    model: "3-Layer Garden Pipe",
    brochure: BROCHURES.garden,
    brochureImage: BROCHURES.garden,
    short: "For a greener garden & better tomorrow — eco-friendly, non-toxic, lead-free 3-layer PVC garden pipe.",
    image: PRODUCT_IMG.garden,
    overview:
      "RK Jain Premium Garden Pipe is a strong, flexible, 3-layer PVC hose made from 100% virgin material. Eco-friendly, non-toxic and lead-free with a UV-protection outer layer, high-strength middle layer and smooth-flow inner layer — perfect for home & professional use.",
    specs: [
      ["Material", "High Quality PVC (100% Virgin Material)"],
      ["Construction", "3-Layer: UV Protection Outer · High Strength Middle · Smooth Flow Inner"],
      ["Colors", "Pink, Green, Orange"],
      ["Eco Friendly", "Non Toxic · Lead Free"],
      ["Available Lengths", "15 MTR | 30 MTR | 50 MTR"],
    ],
    sizes: [
      '1/2" (12mm) — 15/30/50 MTR',
      '5/8" (16mm) — 15/30/50 MTR',
      '3/4" (19mm) — 15/30/50 MTR',
      '1" (25mm) — 15/30/50 MTR',
    ],
    features: [
      "Strong & Durable — high quality PVC for extra strength & long life",
      "Flexible & Kink Resistant — tangle free & easy to roll",
      "UV & Weather Proof — resistant to sunlight, heat & all weather",
      "Smooth Water Flow — designed for maximum water flow",
      "Eco Friendly — lead free, non toxic & safe for environment",
    ],
    advantages: [
      "Light Weight & Easy to Carry",
      "Extra Flexible for Easy Use",
      "Bursting Pressure Resistant",
      "Made from High Quality PVC",
      "Perfect for Home & Professional Use",
    ],
    applications: ["Residential", "Commercial", "Agriculture", "Construction"],
  },
  {
    slug: "high-pressure-car-washer-rk-2100",
    name: "High Pressure Car Washer (RK-2100)",
    category: "STP",
    subcategory: "Car Washer",
    model: "RK-2100",
    brochure: BROCHURES.carwasher,
    brochureImage: BROCHURES.carwasher,
    short: "2100W Power | 150 Bar Pressure — powerful high-pressure washer for cleaning Car, Bike & Home.",
    image: PRODUCT_IMG.carwasher,
    overview:
      "The RK Jain High Pressure Car Washer (RK-2100) delivers 2100W of power and 150 Bar of pressure for deep cleaning of cars, bikes and homes. Complete with a full accessory kit — foam cannon, spray gun, hoses and more — for professional cleaning at home.",
    specs: [
      ["Model", "RK-2100"],
      ["Power", "2100 Watt"],
      ["Max Pressure", "150 Bar"],
      ["Flow Rate", "8.5 L/min"],
      ["No Load Speed", "2800 RPM"],
      ["Voltage", "220V / 50Hz"],
      ["Auto Stop", "Yes"],
    ],
    sizes: ["Accessories: Foam Cannon, Water Filter, Inlet Connector, Hose Connector, Tap Adaptor, Spray Gun, High Pressure Hose, Pipe, Microfiber Glove"],
    features: [
      "150 BAR — high pressure for deep cleaning",
      "2100W Powerful Induction Motor — high performance & long life",
      "8.5 L/min Flow Rate — high water flow for better cleaning",
      "Auto Stop System — saves energy & increases pump life",
      "Overheat Protection — motor safety with thermal protector",
      "Compact & Portable — easy to carry, easy to use",
    ],
    advantages: [
      "Strong & Durable Build",
      "Powerful Performance",
      "Water & Energy Saving",
      "Best Quality Best Result",
    ],
    applications: ["Residential", "Commercial", "Industrial"],
  },
  {
    slug: "black-white-mulching-film",
    name: "Black White Mulching Film",
    category: "Drip Irrigation",
    subcategory: "Mulching Film",
    model: "50 / 75 / 100 Micron",
    brochure: BROCHURES.mulching,
    brochureImage: BROCHURES.mulching,
    short: "For a better start to advanced farming — UV stabilized mulching film for higher yield & weed control.",
    image: PRODUCT_IMG.mulching,
    overview:
      "RK Jain Black White Mulching Film retains soil moisture, controls weeds and maintains optimum soil temperature for better crop productivity. Made from premium raw material with UV stabilisation for longer life — suitable for all types of soil and crops.",
    specs: [
      ["Type", "Black / White Mulching Film"],
      ["Available Thickness", "50 Micron · 75 Micron · 100 Micron"],
      ["Key Benefit", "UV Stabilized · Water Saving · Weed Control · High Yield"],
      ["Raw Material", "Premium Quality"],
    ],
    sizes: ["50 Micron", "75 Micron", "100 Micron"],
    features: [
      "Better Soil Moisture — retains moisture & reduces water evaporation",
      "Weed Control — controls weed growth & reduces herbicide use",
      "Temperature Control — maintains optimum soil temperature",
      "Better Plant Growth — improves yield, quality & early maturity",
      "UV Stabilized — longer life with premium UV protection",
    ],
    advantages: [
      "Premium Quality Raw Material",
      "Extra Strong & Durable",
      "Better Crop Productivity",
      "Cost Effective & Long Lasting",
      "Suitable for All Types of Soil & Crops",
    ],
    applications: ["Agriculture", "Irrigation"],
  },
  {
    slug: "column-pipes-borewell",
    name: "Column Pipes",
    category: "Pipes",
    subcategory: "Borewell Column Pipe",
    model: "Impact-Sustaining Lock System",
    brochure: BROCHURES.columnpipe,
    brochureImage: BROCHURES.columnpipe,
    short: "Borewell pipes for deep water extraction — 1st in India impact-sustaining lock system.",
    image: PRODUCT_IMG.columnpipe,
    overview:
      "RK Jain Column Pipes are borewell pipes built for deep water extraction, featuring India's 1st impact-sustaining lock system for leak-proof, secure joints. Lead-free and safe with high durability, a smooth finish for better flow, and premium raw material.",
    specs: [
      ["Type", "Borewell Column Pipe"],
      ["Lock System", "Impact-Sustaining Lock System (1st in India)"],
      ["Material", "Lead-Free & Safe (Pure & Non-Toxic)"],
      ["Available Sizes", '32mm (1¼") · 40mm (1½") · 50mm (2") · 63mm (2½") · 75mm (3") · 90mm (4")'],
    ],
    sizes: ['32 mm (1¼")', '40 mm (1½")', '50 mm (2")', '63 mm (2½")', '75 mm (3")', '90 mm (4")', "And other sizes available"],
    features: [
      "Impact-Sustaining Lock System — leak proof & secure joint",
      "Lead-Free & Safe — pure & non-toxic",
      "High Durability & Strength — long life & corrosion resistant",
      "Smooth Finish Better Flow — maximum water discharge",
      "Advanced Technology — made with premium raw material",
    ],
    advantages: [
      "High Strength & Reliability",
      "Rust & Corrosion Resistant",
      "Easy Installation & Maintenance",
      "100% Leak Proof Performance",
    ],
    applications: ["Water Supply", "Agriculture", "Industrial"],
  },
  {
    slug: "drip-irrigation-tape",
    name: "RK Jain Rain Pipe",
    category: "Drip Irrigation",
    subcategory: "Drip Irrigation",
    model: "Flat Dripper",
    brochure: BROCHURES.drip,
    brochureImage: BROCHURES.drip,
    short: "Samruddhi zindagi bhar — high quality LDPE drip tape for uniform water delivery & better yield.",
    image: PRODUCT_IMG.drip,
    overview:
      "RK Jain Drip Irrigation Tape delivers precise, uniform water directly to plant roots — saving water, improving yield and cutting costs. Made from high-quality LDPE with a flat dripper design, UV & chemical resistant, anti-clogging and built for multi-season performance.",
    specs: [
      ["Type", "Drip Irrigation Tape (Flat)"],
      ["Material", "High Quality LDPE"],
      ["Wall Thickness", "100 / 125 / 150 Micron"],
      ["Width", "16 mm / 20 mm"],
      ["Emitter Type", "Flat Dripper"],
      ["Emitter Spacing", "20 cm / 30 cm / 40 cm"],
      ["Roll Length", "1000 Meter / Roll"],
    ],
    sizes: ["16 mm", "20 mm"],
    features: [
      "Uniform Water Delivery — precise distribution to roots",
      "High Durability — premium quality raw material for long life",
      "UV Resistant — withstands harsh sunlight and extreme weather",
      "Chemical Resistant — safe with fertilizers, chemicals and acidic water",
      "Long Life — designed for multi-season performance",
      "Eco Friendly — saves water, energy and protects the environment",
    ],
    advantages: [
      "Anti Clogging",
      "High Pressure Resistant",
      "Easy to Install",
      "Made in India",
    ],
    applications: ["Vegetables", "Sugarcane", "Fruits", "Flowers", "Cotton & Other Crops"],
  },
  {
    slug: "mud-pump",
    name: "RK Jain Mud Pump",
    category: "Pumps",
    subcategory: "Centrifugal Mud Pump",
    model: "0.5 HP - 5 HP",
    brochure: BROCHURES.mudpump,
    brochureImage: BROCHURES.mudpump,
    short: "Powering every drop, growing every crop — heavy duty mud pump for mud, slurry & dirty water.",
    image: PRODUCT_IMG.mudpump,
    overview:
      "RK Jain Mud Pump is specially designed for pumping mud, slurry and dirty water in agriculture, construction and dewatering applications. Built with a heavy-duty cast iron body and high-grade copper winding motor for long life and reliable performance.",
    specs: [
      ["Type", "Centrifugal Mud Pump"],
      ["Material", "Cast Iron"],
      ["Power Range", "0.5 HP to 5 HP"],
      ["Phase", "Single Phase / Three Phase"],
      ["Speed", "1440 RPM"],
      ["Delivery Size", '25 mm to 100 mm (1" to 4")'],
      ["Application", "Mud, Slurry, Dirty Water, Construction & Dewatering"],
    ],
    sizes: ["0.5 HP", "1 HP", "2 HP", "3 HP", "5 HP"],
    features: [
      "Heavy Duty Construction — strong & durable cast iron body",
      "High Discharge Capacity — delivers high flow for mud, slurry & waste water",
      "Copper Winding Motor — high grade copper for better performance & longer life",
      "Corrosion & Rust Resistant — special coating for protection",
      "Low Maintenance — simple design, easy installation",
      "Energy Efficient — consumes less power & saves energy",
    ],
    advantages: [
      "Handles mud, slurry & dirty water easily",
      "High efficiency & reliable performance",
      "Long service life",
      "Suitable for continuous operation",
      "Ideal for heavy duty applications",
    ],
    applications: ["Construction Sites", "Dewatering", "Slurry & Waste Water", "Sand & Mud Transfer", "Agricultural Applications"],
  },
  {
    slug: "electric-motor",
    name: "RK Jain Electric Motor",
    category: "Pumps",
    subcategory: "Electric Motor",
    model: "0.5 HP - 25 HP",
    brochure: BROCHURES.motor,
    brochureImage: BROCHURES.motor,
    short: "Powering every machine, driving every success — 100% copper winding, high efficiency & long life.",
    image: PRODUCT_IMG.motor,
    overview:
      "RK Jain Electric Motor is built with advanced technology and premium quality materials to deliver powerful performance, energy efficiency and reliability in every application. 100% copper winding for high efficiency, Class F insulation and heavy-duty cast iron body for long life.",
    specs: [
      ["Power Range", "0.5 HP to 25 HP"],
      ["Phase", "Single Phase & Three Phase"],
      ["Speed", "1440 RPM & 2880 RPM"],
      ["Mounting", "Foot Mounted & Flange Mounted"],
      ["Winding", "100% Copper"],
      ["Insulation", "Class F"],
      ["Body", "Heavy Duty Cast Iron"],
      ["Warranty", "12 Months"],
    ],
    sizes: ["0.5 HP", "1 HP", "2 HP", "3 HP", "5 HP", "7.5 HP", "10 HP", "15 HP", "20 HP", "25 HP"],
    features: [
      "100% Copper Winding — high efficiency, better performance & longer life",
      "High Starting Torque — powerful start and smooth operation under heavy load",
      "Energy Efficient — consumes less power and saves electricity",
      "Heavy Duty Construction — strong cast iron body for extra durability",
      "Low Noise & Vibration — precision balanced rotor for smooth, quiet performance",
      "Class F Insulation — withstands high temperature",
      "Corrosion Resistant — specially coated surface for rust resistance",
      "Easy Installation & Low Maintenance",
    ],
    advantages: [
      "High Efficiency, Low Power Consumption",
      "Reliable & Continuous Operation",
      "Excellent Overload Capacity",
      "Durable & Dependable Performance",
      "Reduced Maintenance Cost",
      "Suitable for Heavy Duty Applications",
    ],
    applications: ["Water Pumps", "Monoblock Pumps", "Agricultural Machinery", "Industrial Equipment", "Compressors", "Construction Machinery", "Blowers & General Use"],
  },
  {
    slug: "disc-filter",
    name: "RK Jain Disc Filter",
    category: "Drip Irrigation",
    subcategory: "Disc Filter",
    model: "Disc Type (Modular)",
    brochure: BROCHURES.discfilter,
    brochureImage: BROCHURES.discfilter,
    short: "Pure water for better crops — 120 mesh disc filter for drip, sprinkler & micro irrigation.",
    image: PRODUCT_IMG.discfilter,
    overview:
      "RK Jain Disc Filter is designed to remove suspended impurities from water and protect your irrigation system for smooth, clog-free performance. Built with high quality engineering plastic — efficient filtration, long life and low maintenance.",
    specs: [
      ["Filter Type", "Disc Type (Modular)"],
      ["Material", "High Quality Engineering Plastic"],
      ["Filtration Grade", "120 Mesh (130 Micron)"],
      ["Inlet / Outlet Size", '2" / 2", 3" / 3" (BSP / NPT)'],
      ["Max. Working Pressure", "8.0 kg/cm² (116 PSI)"],
      ["Max. Flow Rate", "25 - 40 m³/h (Depends on Model)"],
      ["Max. Working Temperature", "60°C"],
      ["Cleaning Method", "Manual"],
      ["Application", "Drip Irrigation, Sprinkler, Micro Irrigation, Industrial & General Water Filtration"],
    ],
    sizes: ['2" / 2"', '3" / 3"'],
    features: [
      "High Filtration Efficiency — disc technology traps fine particles",
      "Durable & Corrosion Resistant — engineering plastic for long life",
      "Easy to Clean — simple disc removal & cleaning",
      "Low Pressure Loss — optimal flow with minimum resistance",
      "Strong & Reliable — robust design for tough field conditions",
    ],
    advantages: [
      "Protects emitters & nozzles from clogging",
      "Ensures uniform water distribution",
      "Increases life of irrigation system",
      "Saves water & energy",
      "Easy installation",
      "Cost effective solution",
    ],
    applications: ["Drip Irrigation", "Sprinkler Irrigation", "Nursery & Greenhouse", "Industrial Applications"],
  },
  {
    slug: "heavy-duty-chaff-cutter",
    name: "RK Jain Chaff Cutter (Heavy Duty)",
    category: "Chaff Cutter",
    subcategory: "Chaff Cutter",
    model: "3 HP / 5 HP / 7.5 HP",
    brochure: BROCHURES.chaffbig,
    brochureImage: BROCHURES.chaffbig,
    short: "Powerful · Durable · Efficient — heavy duty chaff cutter for green & dry fodder, sugarcane, maize.",
    image: PRODUCT_IMG.chaffbig,
    overview:
      "RK Jain Chaff Cutter is a high performance, heavy duty fodder cutting machine for all your farm needs. Multi-crop use with high speed blades, powerful motor and a robust mild steel body — cuts green & dry fodder, grass, straw, maize stalks, sugarcane and more.",
    specs: [
      ["Motor Power", "3 HP / 5 HP / 7.5 HP (Options)"],
      ["Power Source", "Electric Motor / Diesel Engine"],
      ["Cutting Capacity", "1000 - 2500 kg/hr (Approx.)"],
      ["No. of Blades", "4 High Speed Blades"],
      ["Material", "Mild Steel (Heavy Duty)"],
      ["Cutting Size", "10 - 25 mm (Adjustable)"],
      ["Application", "Green & Dry Fodder, Grass, Maize, Sugarcane, Straw"],
    ],
    sizes: ["3 HP", "5 HP", "7.5 HP"],
    features: [
      "Powerful Performance — high speed blades & powerful motor for efficient cutting",
      "Multi Crop Use — green & dry fodder, grass, straw, maize stalks, sugarcane and more",
      "Strong & Durable — heavy duty body from high quality steel",
      "High Output — saves time and labor, improves feeding efficiency",
      "Easy to Operate — simple to use and low maintenance",
    ],
    advantages: [
      "Increases milk production",
      "Improves animal health",
      "Reduces feed wastage",
      "Saves time & labor",
      "Cost effective & high efficiency",
    ],
    applications: ["Cow", "Buffalo", "Goat", "Sheep", "Poultry", "Dairy Farm", "Biogas Plant"],
  },
  {
    slug: "pepsi-drip",
    name: "RK Jain Pepsi Drip",
    category: "Drip Irrigation",
    subcategory: "Drip Irrigation",
    model: "Premium Drip Irrigation System",
    brochure: BROCHURES.pepsidrip,
    brochureImage: BROCHURES.pepsidrip,
    short: "Har Boond Ki Bachat, Har Khet Ki Sachat — premium drip irrigation system for higher yield.",
    image: PRODUCT_IMG.pepsidrip,
    overview:
      "RK Jain Pepsi Drip is a premium drip irrigation system built for precise, uniform water delivery to every crop. Turbo flow labyrinth design offers better clog resistance, UV stabilised for long life and made in India from high-quality raw material.",
    specs: [
      ["Type", "Premium Drip Irrigation System"],
      ["Available Sizes", "16 mm / 20 mm / 25 mm"],
      ["Length", "500 Meter / Roll"],
      ["Design", "Turbo Flow Labyrinth"],
      ["UV", "UV Stabilized"],
      ["Origin", "Made in India"],
    ],
    sizes: ["16 mm", "20 mm", "25 mm"],
    features: [
      "Turbo flow labyrinth for better clog resistance",
      "Precise & uniform water distribution",
      "Suitable for all types of soil & crops",
      "Water Saving — high uniform emission",
      "Durable & Long Lasting — UV stabilized",
      "Easy to install & maintain",
    ],
    advantages: [
      "Saves up to 50% Water",
      "Improves Crop Yield",
      "Reduces Weeds",
      "Saves Time & Labour",
      "More Crop, More Profit",
    ],
    applications: ["Vegetables", "Sugarcane", "Cotton", "Onion", "Pulses"],
  },
  {
    slug: "round-drip",
    name: "RK Jain Round Drip",
    category: "Drip Irrigation",
    subcategory: "Drip Irrigation",
    model: "Premium Drip Irrigation System",
    brochure: BROCHURES.rounddrip,
    brochureImage: BROCHURES.rounddrip,
    short: "Har Boond Ki Bachat, Har Khet Ki Sachat — round design for better flow and high durability.",
    image: PRODUCT_IMG.rounddrip,
    overview:
      "RK Jain Round Drip is a premium drip irrigation system with a round design for better flow and high durability. Turbo flow labyrinth for better clog resistance, UV stabilised and made in India from high quality raw material.",
    specs: [
      ["Type", "Premium Drip Irrigation System (Round Design)"],
      ["Available Sizes", "16 mm / 20 mm / 25 mm"],
      ["Length", "500 Meter / Roll"],
      ["Design", "Round for Better Flow & High Durability"],
      ["UV", "UV Stabilized"],
      ["Origin", "Made in India"],
    ],
    sizes: ["16 mm", "20 mm", "25 mm"],
    features: [
      "Turbo flow labyrinth for better clog resistance",
      "Precise & uniform water distribution",
      "Suitable for all types of soil & crops",
      "Water Saving — uniform emission",
      "Durable & Long Lasting — UV stabilized",
      "Easy to install & maintain",
      "High quality raw material for long life",
    ],
    advantages: [
      "Saves up to 50% Water",
      "Improves Crop Yield",
      "Reduces Weeds",
      "Saves Time & Labour",
      "More Profit",
    ],
    applications: ["Sugarcane", "Vegetables", "Onion", "Cotton", "Groundnut", "Pulses"],
  },
  {
    slug: "copper-cable",
    name: "RK Jain Copper Cable",
    category: "Cables",
    subcategory: "Copper Cable",
    model: "1.0 - 35 Sq. mm",
    brochure: BROCHURES.coppercable,
    brochureImage: BROCHURES.coppercable,
    short: "Strong connection. Powerful performance — 100% pure copper cable with premium PVC insulation.",
    image: PRODUCT_IMG.coppercable,
    overview:
      "RK Jain Copper Cable is built with 100% pure copper for high conductivity and maximum performance. Premium PVC insulation, extra flexible & tangle free, low resistance for high efficiency — trusted by professionals for water pumps, agriculture, wiring and industrial use.",
    specs: [
      ["Conductor", "100% Pure Copper"],
      ["Insulation", "Premium Quality PVC"],
      ["Available Sizes", "1.0, 1.5, 2.5, 4.0, 6.0, 10.0, 16.0, 25.0, 35.0 Sq. mm"],
      ["Length Options", "90 MTR / 180 MTR / 270 MTR (Other sizes on request)"],
      ["Application", "Water Pumps, Agriculture, Residential Wiring, Industrial, Power Distribution"],
    ],
    sizes: ["1.0 Sq. mm", "1.5 Sq. mm", "2.5 Sq. mm", "4.0 Sq. mm", "6.0 Sq. mm", "10.0 Sq. mm", "16.0 Sq. mm", "25.0 Sq. mm", "35.0 Sq. mm"],
    features: [
      "100% Pure Copper — high conductivity for maximum performance",
      "Strong & Durable — long life, tangle free and highly reliable",
      "High Safety — low resistance, less heat generation, more safety",
      "Moisture Resistant — PVC insulation protects from water, oil & moisture",
      "Heat Resistant — withstands high temperature and harsh conditions",
      "High Insulation Safety & Electrical Safety",
      "Long Life Performance & Tangle Free Design",
    ],
    advantages: [
      "100% Pure Copper",
      "Extra Flexible & Tangle Free",
      "Premium Quality PVC",
      "Low Resistance, High Efficiency",
      "Trusted by Professionals",
    ],
    applications: ["Water Pumps", "Agriculture", "Residential Wiring", "Industrial Applications", "Power Distribution"],
  },
  {
    slug: "power-weeder-rj70-deluxe",
    name: "RK Jain Power Weeder RJ-70 Deluxe",
    category: "STP",
    subcategory: "Power Weeder",
    model: "RJ-70 Deluxe",
    brochure: BROCHURES.weeder,
    brochureImage: BROCHURES.weeder,
    short: "Chhota aakar, badi taakat — 7 HP petrol power weeder for cultivation, weeding & soil preparation.",
    image: PRODUCT_IMG.weeder,
    overview:
      "RK Jain Power Weeder is designed for easy and efficient cultivation, weeding and soil preparation. Ideal for small to medium farms, gardens, vegetable fields and orchards. Powerful 4-stroke petrol engine, sturdy build and easy operation make it a perfect choice for every progressive farmer.",
    specs: [
      ["Engine Type", "4 Stroke Petrol Engine"],
      ["Engine Power", "7 HP"],
      ["Displacement", "212 CC"],
      ["Fuel Tank Capacity", "3.6 Ltr."],
      ["Transmission", "Gear Drive"],
      ["Working Width", "800 - 1000 mm"],
      ["Tilling Depth", "100 - 300 mm"],
      ["No. of Blades", "24 Pcs (4 x 6)"],
      ["Weight", "75 - 85 Kg (Approx.)"],
    ],
    sizes: ["RJ-70 Deluxe"],
    features: [
      "Powerful Engine — 7 HP 4-stroke petrol engine for high performance",
      "Easy to Operate — ergonomic handle and smooth controls",
      "High Fuel Efficiency — low consumption, more work per litre",
      "Heavy Duty Blades — 24 sharp blades for effective tilling",
      "Strong & Durable Build Quality — sturdy frame for long life",
    ],
    advantages: [
      "Powerful Performance",
      "Long Life",
      "Low Maintenance",
      "Trusted by Farmers",
    ],
    applications: ["Weeding", "Soil Cultivation", "Vegetable Farms", "Orchards", "Garden Use"],
  },
  {
    slug: "aluminum-cable",
    name: "RK Jain Aluminum Cable",
    category: "Cables",
    subcategory: "Aluminum Cable",
    model: "1, 2, 3 & 4 Core",
    brochure: BROCHURES.alucable2,
    brochureImage: BROCHURES.alucable2,
    short: "Strong connection. Safe electrical future — 100% pure aluminum conductor cable in 1/2/3/4 core.",
    image: PRODUCT_IMG.alucable2,
    overview:
      "RK Jain Aluminum Cable is built with 100% pure aluminum conductor for high conductivity and maximum performance. Available in 1, 2, 3 & 4 core configurations with superior insulation, heat & moisture resistance, and 100% tested quality for safe, reliable power distribution.",
    specs: [
      ["Conductor", "100% Pure Aluminum"],
      ["Configurations", "1 Core / 2 Core / 3 Core / 4 Core"],
      ["Available Sizes", "1.5, 2.5, 4.0, 6.0, 10.0, 16.0, 25.0, 35.0, 50.0, 70.0 Sq. mm"],
      ["Length Options", "90 MTR / 180 MTR / 270 MTR (Other sizes on request)"],
      ["Application", "Submersible Pump, Residential Wiring, Agriculture, Industrial, Power Distribution"],
    ],
    sizes: ["1.5 Sq. mm", "2.5 Sq. mm", "4.0 Sq. mm", "6.0 Sq. mm", "10.0 Sq. mm", "16.0 Sq. mm", "25.0 Sq. mm", "35.0 Sq. mm", "50.0 Sq. mm", "70.0 Sq. mm"],
    features: [
      "Pure Aluminum Conductor — high conductivity for maximum performance",
      "Strong & Durable — reliable performance for extra strength & long life",
      "High Insulation — superior insulation for safe electrical flow",
      "Heat & Moisture Resistant — withstands high temperature and harsh conditions",
      "Safe & Reliable — 100% tested for quality and safety",
    ],
    advantages: [
      "Fire Retardant",
      "Corrosion Resistant",
      "Flexible & Easy to Install",
      "Long Life Guarantee",
      "100% Quality Assurance",
    ],
    applications: ["Submersible Pump", "Residential Wiring", "Agriculture Use", "Industrial Applications", "Power Distribution"],
  },
  {
    slug: "sprinkler-pipes",
    name: "RK Jain Sprinkler Pipes & Accessories",
    category: "Pipes",
    subcategory: "Sprinkler Irrigation",
    model: "63 mm (2½\") HDPE",
    brochure: BROCHURES.sprinkler,
    brochureImage: BROCHURES.sprinkler,
    short: "Unnat sinchai, behtar fasal — HDPE sprinkler pipes & complete K-type accessories.",
    image: PRODUCT_IMG.sprinkler,
    overview:
      "RK Jain Sprinkler Pipes are manufactured from high quality raw material for long life, high pressure tolerance and excellent performance. Ideal for all types of agricultural irrigation systems — with a complete range of K-type accessories.",
    specs: [
      ["Product Name", "Sprinkler Pipes & Accessories"],
      ["Material", "HDPE / Metal / Brass"],
      ["Pipe Diameter", "63 mm (2½\")"],
      ["Pipe Thickness", "4.0 mm / 5.0 mm"],
      ["Standard Length", "3 Meter / 6 Meter"],
      ["Working Pressure", "Up to 6 kg/cm²"],
      ["Application", "Agriculture Irrigation"],
      ["Color", "Black"],
      ["Features", "UV Stabilized, Leak Proof, High Pressure Resistant"],
    ],
    sizes: ["63 mm × 3 M", "63 mm × 6 M", "4.0 mm Wall", "5.0 mm Wall"],
    features: [
      "Strong & Durable — high grade HDPE for extra strength and long life",
      "High Pressure Resistant — withstands high water pressure for efficient irrigation",
      "Corrosion & Rust Proof — chemical resistant for all weather conditions",
      "Easy Installation — light weight, easy to assemble and maintain",
      "Uniform Water Distribution",
      "Saves Water & Energy",
      "Suitable for All Types of Soil & Crops",
    ],
    advantages: [
      "Premium Quality Material",
      "Long Lasting Performance",
      "Best for All Irrigation Systems",
      "Trusted by Thousands of Farmers",
      "Leak Proof System",
      "UV Stabilized",
    ],
    applications: ["Agricultural Fields", "Orchards & Plantations", "Vegetable Farms", "Lawns & Gardens", "Greenhouses & Nurseries"],
  },
  {
    slug: "water-transfer-pump",
    name: "RK Jain Water Transfer Pump",
    category: "STP",
    subcategory: "Petrol Water Pump",
    model: "5.5 HP Petrol",
    brochure: BROCHURES.watertx,
    brochureImage: BROCHURES.watertx,
    short: "Strong flow. Reliable performance — 5.5 HP 4-stroke petrol water transfer pump.",
    image: PRODUCT_IMG.watertx,
    overview:
      "RK Jain Water Transfer Pump is a powerful, durable and efficient 4-stroke petrol pump built for fast water transfer in agriculture, borewell, industrial and water supply applications. Portable design with recoil start and heavy-duty frame for tough field conditions.",
    specs: [
      ["Engine Type", "4 Stroke, Petrol Engine"],
      ["Power", "5.5 HP"],
      ["Displacement", "196 cc"],
      ["Max. Output", "163 LPM"],
      ["Suction Lift", "7 Meter"],
      ["Delivery Size", '2 Inch (50 mm)'],
      ["Fuel Tank Capacity", "3.6 Liters"],
      ["Starting System", "Recoil Start"],
      ["Weight", "28 Kg (Approx.)"],
    ],
    sizes: ["5.5 HP / 2 Inch"],
    features: [
      "Powerful Engine — high performance engine for maximum efficiency",
      "High Flow Capacity — designed for faster water transfer & superior output",
      "Durable & Reliable — heavy duty construction for long life & tough conditions",
      "Easy to Use — portable design with easy starting system",
      "High Durability — built with premium quality materials",
      "Fuel Efficient — low fuel consumption for more savings",
      "Low Maintenance — easy maintenance for longer product life",
    ],
    advantages: [
      "Strong Build, Tough Performance",
      "Reliable Operation in Every Condition",
      "Maximum Flow, Better Results",
    ],
    applications: ["Agriculture", "Borewell", "Industrial Use", "Water Supply"],
  },
  {
    slug: "wet-dry-vacuum-cleaner",
    name: "RK Jain Wet & Dry Vacuum Cleaner 25 RT WDVC",
    category: "Vacuum",
    subcategory: "Vacuum Cleaner",
    model: "25 RT WDVC",
    brochure: BROCHURES.vacuum,
    brochureImage: BROCHURES.vacuum,
    short: "Cleaner spaces, healthier life — 1600 W, 25 L wet & dry vacuum with blower function.",
    image: PRODUCT_IMG.vacuum,
    overview:
      "RK Jain 25 RT WDVC is a powerful, durable and reliable wet & dry vacuum cleaner with heavy duty motor, 25 L capacity and blower function. Ideal for home, office, hotel, workshop and car cleaning — clean every corner, care everywhere.",
    specs: [
      ["Model", "25 RT WDVC"],
      ["Power", "1600 Watts"],
      ["Capacity", "25 L"],
      ["Air Flow", "53 L/S"],
      ["Vacuum Suction", "200 mBAR"],
      ["Voltage / Frequency", "220V / 50 Hz"],
    ],
    sizes: ["25 L"],
    features: [
      "Wet & Dry Cleaning",
      "Powerful Suction",
      "Heavy Duty Motor",
      "Blower Function",
      "Easy to Use & Maintain",
      "Easy Transport & Guaranteed Quality",
    ],
    advantages: [
      "Strong & Durable",
      "High Performance Motor",
      "Wet & Dry Application",
      "Trusted by Professionals",
    ],
    applications: ["Home", "Office", "Hotel", "Workshop", "Car Cleaning"],
  },
  {
    slug: "generator",
    name: "RK Jain Generator",
    category: "Generator",
    subcategory: "Diesel Generator",
    model: "Diesel Engine Generator",
    brochure: BROCHURES.generator,
    brochureImage: BROCHURES.generator,
    short: "Powering every need, anywhere anytime — heavy-duty diesel generator for irrigation & industry.",
    image: PRODUCT_IMG.generator,
    overview:
      "RK Jain Generator is a heavy-duty diesel generator engineered for continuous, reliable power in agriculture, borewell, industrial and water supply applications. Powerful motor, strong build and easy maintenance make it a trusted choice for tough field conditions.",
    specs: [
      ["Engine Type", "Diesel Engine"],
      ["Power", "As per Model (HP)"],
      ["Speed", "As per Model (RPM)"],
      ["Frequency", "As per Model (Hz)"],
      ["Phase", "Single Phase / Three Phase"],
      ["Starting System", "Manual Start / Electric Start"],
      ["Fuel Type", "Diesel"],
      ["Fuel Tank Capacity", "As per Model (Litre)"],
      ["Voltage", "As per Model (V)"],
      ["Application", "Irrigation, Agricultural, Borewell, Industrial"],
    ],
    sizes: ["Multiple HP options — call for exact rating"],
    features: [
      "High Efficiency — maximum output with minimum power consumption",
      "Long Life — built to last for years",
      "Powerful Motor — high performance for longer life",
      "Strong & Durable — heavy duty construction for tough conditions",
      "Easy Maintenance — simple design for easy service and operation",
      "Reliable Performance — consistent output in every condition",
      "Rust Resistant",
    ],
    advantages: [
      "Premium Quality Materials",
      "Advanced Technology",
      "Tested for Reliability",
      "Best Performance Assured",
    ],
    applications: ["Agriculture", "Borewell", "Industrial Use", "Water Supply", "Irrigation"],
  },
  {
    slug: "monoblock-pump",
    name: "RK Jain Monoblock Pump",
    category: "Pumps",
    subcategory: "Centrifugal Monoblock Pump",
    model: "0.5 HP - 5.0 HP",
    brochure: BROCHURES.monoblock,
    brochureImage: BROCHURES.monoblock,
    short: "Powering every drop, growing every crop — compact, high performance centrifugal monoblock pump.",
    image: PRODUCT_IMG.monoblock,
    overview:
      "RK Jain Monoblock Pump is a compact and high performance pump suitable for domestic, agricultural and industrial water pumping applications. Designed for efficient operation, low maintenance and long lasting performance — with copper winding motor and cast iron body.",
    specs: [
      ["Model", "RK Jain Monoblock Pump"],
      ["Type", "Centrifugal Monoblock Pump"],
      ["Material", "Cast Iron"],
      ["Power Range", "0.5 HP to 5.0 HP"],
      ["Phase", "Single Phase / Three Phase"],
      ["Speed", "1440 RPM"],
      ["Delivery Size", '25 mm to 100 mm (1" to 4")'],
      ["Head Range", "Up to 50 Meter"],
      ["Application", "Domestic, Agricultural, Industrial, Construction"],
    ],
    sizes: ["0.5 HP", "1 HP", "2 HP", "3 HP", "5 HP"],
    features: [
      "High Efficiency — optimized design for maximum water output with minimum power",
      "Compact & Strong Design — monoblock construction ensures strength, compactness & durability",
      "Copper Winding Motor — high grade copper winding for better performance & longer life",
      "Rust & Corrosion Resistant — special anti-rust treatment for long life in tough conditions",
      "Low Maintenance — simple design for easy installation and minimal maintenance",
      "Energy Efficient — consumes less power and helps in saving energy",
    ],
    advantages: [
      "High Efficiency & Reliable Performance",
      "Long Service Life",
      "Low Power Consumption",
      "Smooth & Vibration Free Operation",
      "Suitable for Continuous Operation",
      "Ideal for Domestic, Agricultural & Industrial Use",
    ],
    applications: ["Domestic Water Supply", "Agricultural Irrigation", "Construction Sites", "Industrial Use", "Dewatering Applications"],
  },
];

import { PRODUCTS_MR } from "@/lib/productsI18n";

export function getProduct(slug) {
  return PRODUCTS.find((p) => p.slug === slug);
}

// Merge English base product with Marathi overrides for the active language.
export function localizeProduct(product, lang) {
  if (lang !== "mr" || !product) return product;
  const mr = PRODUCTS_MR[product.slug];
  if (!mr) return product;
  return { ...product, ...mr };
}

export function relatedProducts(product, count = 3) {
  return PRODUCTS.filter(
    (p) => p.category === product.category && p.slug !== product.slug
  ).slice(0, count);
}
